import { render } from "./WarrantyModal.vue?vue&type=template&id=067ae235&scoped=true"
import script from "./WarrantyModal.vue?vue&type=script&lang=js"
export * from "./WarrantyModal.vue?vue&type=script&lang=js"

import "./WarrantyModal.vue?vue&type=style&index=0&id=067ae235&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067ae235"]])

export default __exports__